import { Injectable } from '@angular/core';
import { BdbRequest, BdbSessionStrgService } from '@npm-bbta/bbog-cm-auth-lib';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ServiceErrorEnum } from '../../enums/service-error.enum';
import { SendOtpHttpStatusEnum } from '../validate-otp/send-otp-http-status.enum';
import { RedirectService } from '../../shared/redirect.service';
import { Router } from '@angular/router';

@Injectable()
export class OneTimePasswordService {

    constructor(
        private bdbRquest: BdbRequest,
        private redirectService: RedirectService,
        private router: Router,
        private bdbSessionStrgService: BdbSessionStrgService,
    ) { }

    sendOneTimePasswordOffice(requestData: any): Observable<any> {
        const urlOTPService = environment.endpointCifin + 'authentication/send-one-time-password-office';
        return this.bdbRquest.requestPostHeaders(urlOTPService, requestData);
    }

    validateOneTimePasswordOffice(data: any): Observable<any> {
        const urlOTPService = environment.endpointCifin + 'authentication/validate-one-time-password-office';
        return this.bdbRquest.requestPostHeaders(urlOTPService, data);
    }

    public redirectToSendOtpError(status: string) {
        switch (status) {
            case SendOtpHttpStatusEnum.BLOCKED_BY_SECURITY_DAYS:
                this.redirectToBlockedScreenOrNoAuthenticated(ServiceErrorEnum.BLOCKED_BY_SECURITY_DAYS);
                break;
            case SendOtpHttpStatusEnum.BLOCKED_BY_SECURITY_MONTHS:
                this.redirectToBlockedScreenOrNoAuthenticated(ServiceErrorEnum.BLOCKED_BY_SECURITY_MONTHS);
                break;
            case SendOtpHttpStatusEnum.BLOCKED_BY_SECURITY_IP:
                this.redirectToErrorScreen(ServiceErrorEnum.BLOCKED_BY_SECURITY_IP);
                break;
            case SendOtpHttpStatusEnum.BLOCKED_BY_IP_INQUIRY:
                this.redirectToErrorScreen(ServiceErrorEnum.BLOCKED_BY_IP_INQUIRY);
                break;
            case SendOtpHttpStatusEnum.BLOCKED_PHONE_BY_MANY_USERS:
                this.redirectToErrorScreen(ServiceErrorEnum.BLOCKED_PHONE_BY_MANY_USERS);
                break;
            case SendOtpHttpStatusEnum.BLOCKED_PHONE_BY_REEXPEDITION:
                this.redirectToErrorScreen(ServiceErrorEnum.BLOCKED_PHONE_BY_REEXPEDITION);
                break;
            case SendOtpHttpStatusEnum.BLOCKED_INVALID_IDENTIFICATION_NUMBER:
                this.redirectToErrorScreen(ServiceErrorEnum.BLOCKED_INVALID_IDENTIFICATION_NUMBER);
                break;
            default:
                this.redirectToErrorScreen(ServiceErrorEnum.SEND_OTP_SERVICE_ERROR);
        }
    }

    public redirectToBlockedScreenOrNoAuthenticated(serviceErrorEnum: ServiceErrorEnum): void {
        if (this.redirectService.siteIsAllowedToRedirectOnAuthFailure()) {
            this.redirectService.redirectFailedAuthentication();
        } else {
            this.redirectToErrorScreen(serviceErrorEnum);
        }
    }

    public redirectToErrorScreen(errorCode: string): void {
        this.bdbSessionStrgService.save('errorCode', errorCode);
        this.router.navigate(['error']);
    }
}



// WEBPACK FOOTER //
// ./src/app/bdb-one-time-password/services/bdb-otp.service.ts